import { post, get } from "../request";
const proxy = "";
// 新建文件夹
export function addFolder(data) {
  return post("/ProxyAdmin/v1/seller/material/savePath", data);
}
// 获取文件和目录列表
export function getFolderList(data) {
  return get("/ProxyAdmin/v1/seller/material/list", data);
}
// 保存文件
export function saveFile(data, config) {
  return post("/ProxyAdmin/v1/seller/material/saveFile", data, "json", {
    ...config,
  });
}
// 桌面录课器上传到后台素材中心:复用后台素材接口,提供给 desktop bridge 调用。
export function saveDesktopUploadMaterialFile(data, config) {
  return saveFile(data, config);
}
// 删除文件
export function deleteFile(data) {
  return post("/v1/material/delDoc", data);
}
// 获取oss上传地址
export function getOssUrl(data) {
  return get("/ProxyAdmin/v1/seller/material/getSignUrl", data);
}

// 删除文件或目录
export function deleteFolder(data) {
  return post("/ProxyAdmin/v1/seller/material/delete", data);
}
// 移动文件
export function moveFolder(data) {
  return post("/ProxyAdmin/v1/seller/material/move", data);
}
// 获取下载地址
export function getSignDownloadUrl(data) {
  return get("/ProxyAdmin/v1/seller/material/getSignDownloadUrl", data);
}
// 获取签名
export function getSign(data) {
  return get("/ProxyAdmin/v1/seller/material/getSign", data);
}
// 桌面录课器上传到后台素材中心:复用后台素材接口,提供给 desktop bridge 调用。
export function getDesktopUploadMaterialSign(data) {
  return getSign(data);
}
// 获取素材目录树
export function getMaterialTree(data) {
  return get("/ProxyAdmin/v1/seller/material/pathTree", data);
}
// 获取文件夹里的文件
export function getFileList(data) {
  return get("/ProxyAdmin/v1/seller/material/allFile", data);
}
// 删除私有课件

export function deletePrivateCourseware(data) {
  return post(proxy + "/v1/seller/material/doc/del", data);
}
// 获取私有课件列表
export function getPrivateCoursewareList(data) {
  return get(proxy + "/v1/seller/material/doc/list", data);
}
// 机构课件库添加至私有课件
export function addPrivateCoursewareFromLibrary(data) {
  return post(proxy + "/v1/seller/material/doc/add", data);
}
// 前台上传获取签名
export function getUploadSignature(data) {
  return get(proxy + "/v1/cos/getSign", data);
}
